import { createSingleEntityStore, ngrxEvent } from '@recruitee/ngrx';

import { EntityStoreKey } from '../../types';
import {
  OfferContentGeneratorRequest,
  OfferContentGeneratorResponse,
} from './offer-content-generator.types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<OfferContentGeneratorResponse>()(EntityStoreKey.OfferContentGenerator, {
    customActions: adapter => ({
      fetch: (state, _payload: OfferContentGeneratorRequest) => adapter.markAsPending(state),
      fetchEventStream: (state, _payload: OfferContentGeneratorRequest) =>
        adapter.markAsPending(state),
      updateEventStream: (state, payload: OfferContentGeneratorResponse) =>
        adapter.update(state, payload),
      fetchEventStreamAbort: ngrxEvent<void>(),
      fetchEventSuccess: state => adapter.markAsLoaded(state),
      fetchEventFailed: (state, err: string) => adapter.setError(state, Error(err)),
    }),
  });

export {
  actions as OfferContentGeneratorActions,
  selectors as OfferContentGeneratorSelectors,
  reducer as OfferContentGeneratorReducer,
  namespace as OfferContentGeneratorNamespace,
};
